module.exports = __webpack_public_path__ + "static/media/sharefriend.08f63e28.png";